import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { TreeSelect } from 'antd'
import { TreeSelectProps } from 'antd/lib/tree-select'
import { http } from '@ud/admin-framework'

const RoleTreeSelect: React.FC<IRoleTreeSelectProps> = (props) => {
  const [value, setValue] = useState<any>(undefined)
  const [treeNodes, setTreeNodes] = useState<any>([])

  const treeSelectFn = (tree: any) => {
    return Array.isArray(tree) && tree.length && tree.map((item, i) => {
      if (item.children && item.children.length) {
        return <TreeSelect.TreeNode disabled={item.status === 0 ? true : false} value={item.value} title={item.title} key={item.value}>
          {treeSelectFn(item.children)}
        </TreeSelect.TreeNode>
      }
      return <TreeSelect.TreeNode disabled={item.status === 0 ? true : false} value={item.value} title={item.title} key={item.value} />
    })
  }

  const getTreeData = () => {
    // 之前用的接口是返回的所有的角色--不对
    const params = {
      id: '0'
    }
    const url = '/manage/uaa/query/getRoleTree'
    // const url = '/api/uaa/soa/userService/getUserById'
    http.post(url, params).then((res) => {
      if (res.data && res) {
        const dataList = res.data
        dataList.forEach((item: any) => {
          item.status = 0
        })
        const newData: any = treeSelectFn(dataList)
        setTreeNodes(newData)
      }
    })
  }

  const onChange = (value: any) => {
    props.onChange(value)
  }

  useEffect(() => {
    const value = _.cloneDeep(props.value)
    if (_.isArray(props.value)) {
      const str: any = value ? value.map((v: any) => {
        return v.toString()
      }) : undefined
      setValue(str)
    } else {
      setValue(value)
    }
  }, [props.value])

  useEffect(() => {
    getTreeData()
  }, [])
  return (
    <TreeSelect
      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
      allowClear
      multiple
      onChange={onChange}
      placeholder={props.placeholder}
      filterTreeNode={(inputValue: string, treeNode: any) => {
        let name: any = treeNode.props.title
        let value: any = treeNode.props.value
        return name.indexOf(inputValue) > -1 || value.indexOf(inputValue) > -1
      }}
      {...props}
      value={value}
    >
      {treeNodes}
    </TreeSelect>
  )
}

interface IRoleTreeSelectProps extends TreeSelectProps<any> {
  onChange?: any
  placeholder?: string
  value?: any,
  roleList?:any[]
}

export default RoleTreeSelect
